// 宿 QR (2026-09-25, 民泊 PoC Step 1): 宿 (landmark) の部屋ごとの固定 QR 発行 / 一覧 / 無効化。
// api 側: omikuji-api FacilityQrController (system/landmarks/:id/facility-qr-codes)。
//
// auth: ADMIN (全 landmark) / BUSINESS (自分が sponsor の landmark のみ)。

import ApiService from './ApiService';

export type FacilityQrCode = {
    id: number,
    token: string,
    landmark_id: number,
    room_label: string,
    is_active: boolean,
    created_at: string
};

export default class FacilityQrApi extends ApiService {
    // GET /system/landmarks/:landmarkId/facility-qr-codes
    list(landmarkId: string | number) {
        return this.get(`landmarks/${landmarkId}/facility-qr-codes`);
    }

    // POST /system/landmarks/:landmarkId/facility-qr-codes  body: { room_label }
    create(payload: { landmarkId: string | number, roomLabel: string }) {
        return this.post(`landmarks/${payload.landmarkId}/facility-qr-codes`, { room_label: payload.roomLabel });
    }

    // PUT /system/landmarks/:landmarkId/facility-qr-codes/:id  body: { is_active }
    setActive(payload: { landmarkId: string | number, id: number, isActive: boolean }) {
        return this.put(`landmarks/${payload.landmarkId}/facility-qr-codes/${payload.id}`, { is_active: payload.isActive });
    }
}
